import queryString from 'query-string';

import { apiUrl, cancellableRequest } from 'src/services/api.js';
import { createObjectMapper } from 'src/utils/object.js';

const paramsMap = {
  query: 'q',
  order: 'order',
  divisions: 'divisions',
  qualifications: 'qids',
  skills: 'skills',
  ageFrom: 'age_from',
  ageTo: 'age_to',
  salaryFrom: 'salary_from',
  salaryTo: 'salary_to',
  currency: 'currency',
  locations: 'locations',
  excludeLocation: 'exclude_locations',
  companies: 'company_ids',
  excludeCompany: 'not_companies',
  isCurrentCompany: 'current_company',
  universities: 'university_ids',
  excludeUniversity: 'not_universities',
  extraEducations: 'edc_ids',
  excludeExtraEducation: 'not_edcs',
  hasHighEducation: 'with_educations',
  hasExtraEducation: 'with_add_eds',
  hasSalary: 'with_salary',
  hasSocialRatings: 'with_social_ratings',
  hasVisitedLastYear: 'visit_last_year',
  searchFields: 'fields',
  activityPeriod: 'period',
  workStates: 'work_states',
  experiences: 'experiences',
};

const mapLocationParams = createObjectMapper({
  filterEmpty: true,
  defaults: {
    order: 'relevance',
    currency: 'RUR',
  },
  map: paramsMap,
});

const mapRequestParams = createObjectMapper({
  filterEmpty: true,
  map: paramsMap,
});

export const ResumesService = {
  getList(params) {
    return cancellableRequest({
      method: 'get',
      url: `${apiUrl}/resumes`,
      params: mapRequestParams(params),
    });
  },
  getMappedParams(params) {
    return mapLocationParams(params);
  },
  syncLocation(params) {
    const mappedParams = mapLocationParams(params);
    const urlQuery = queryString.stringify(mappedParams,{ arrayFormat: 'bracket' });
    const newUrl = `${window.location.pathname}${urlQuery.length ? '?' : ''}${urlQuery}`;
    window.history.replaceState(params, window.location.title, newUrl);
  }
};

export const ResumesUserFiltersResource = {
  save(params) {
    return cancellableRequest({
      method: 'post',
      url: `${apiUrl}/user_filters/resumes`,
      params: mapRequestParams(params),
    });
  },
  delete({ id }) {
    return cancellableRequest({
      method: 'delete',
      url: `${apiUrl}/user_filters/resumes/${id}`
    });
  },
};
